exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ustYazi[data-v-71b6ad4d]{margin-top:20px}.bad-balance-box[data-v-71b6ad4d]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:10px 12px;border:1px solid #ff9800;border-radius:8px;background-color:#fff3e0;color:#e65100;font-weight:500}", ""]);

// exports
